import {Component, Inject, OnInit, AfterViewInit, ViewChild} from '@angular/core';
import {WarningComponent} from "../../../../../../shared/components/warning/warning.component";
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import {SubmissionComponent} from "../submission/submission.component";
import {NotificationService} from "../../../../../../core/services/notification.service";
import {Subscription} from "rxjs";
import {NgForm} from "@angular/forms";
import {DocumentService} from "../../../../../../core/services/document.service";
import {Message} from "../../../../../../core/class/message";
import {ToastrService} from "ngx-toastr";

@Component({
  selector: 'app-cancel-sign-flow',
  templateUrl: './cancel-sign-flow.component.html',
  styleUrls: ['./cancel-sign-flow.component.scss']
})
export class CancelSignFlowComponent implements OnInit, AfterViewInit {

  document = {
    id: 0,
    reason: ''
  };
  formChangesSubscription: Subscription;
  @ViewChild('f', {static: false}) ngForm: NgForm;

  private isFormChanging: any;
  documentEntity: any;
  private userType: string;
  private success: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<CancelSignFlowComponent>,
    public notificationService: NotificationService,
    private documentService: DocumentService,
    private message: Message,
    private toastr: ToastrService,
  ) {
    this.document.id = data.id;
    this.documentEntity = data.document;
    dialogRef.disableClose = false;
    this.userType = localStorage.getItem('userType');
  }

  ngOnInit() {
    this.notificationService.subscribeErrorService();

  }

  ngAfterViewInit() {
    this.formChangesSubscription = this.ngForm.form.valueChanges.subscribe(() => {
      if (this.ngForm.dirty) {
        this.isFormChanging = true;
      }
    });

    // Focus on textarea reason after load
    // There's a problem if not setTimeout it will focus on 'reason' then lost focus right after
    setTimeout(_ => document.getElementById('reason').focus(), 500);
  }

  cancelSignFlow() {
    // TODO: check quyền huỷ luồng
    this.documentService.cancelSignFlow(this.document).subscribe(rs => {
      this.success = true;
      this.toastr.success(this.message.getMessage('messages.cancel_success'));
      this.dialogRef.close(true);
    });
  }

  cancel() {
    if (this.isFormChanging) {
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '350px',
        data: 'messages.confirm_change_data'
      });
      dialogRe.afterClosed().subscribe(rs => {
        if (rs) {
          this.dialogRef.close();
        }
        dialogRe.close();
      });
    } else {
      this.dialogRef.close();
    }
  }
}
